var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"or-footer bg-white lg:bg-black"},[_c('SplashBar'),(!_vm.isSimpleMode)?_c('Navigation'):_vm._e(),_c('LegalBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }